import * as req from 'api/actions';
import * as c from './constant';

export const getSeniorCitizenList = (
  payload = { type: 'SENIOR' },
  callback
) =>
  req.list(
    c.GET_SENIOR_CITIZEN,
    'api/v1/administrators/social_amelioration_citizens',
    payload,
    callback
  );

  export const showSeniorCitizen = (id, payload, callback) =>
  req.item(
    c.SHOW_SENIOR_CITIZEN,
    `api/v1/administrators/social_amelioration_citizens/${id}`,
    payload,
    callback
  );

  export const approveTransaction = (id, payload, callback) =>
  req.update(
    c.APPROVE_TRANSACTION,
    
    `api/v1/administrators/senior_citizen_imports/${id}`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

  export const rejectTransaction = (id, payload, callback) =>
  req.update(
    c.REJECT_TRANSACTION,
    `api/v1/administrators/senior_citizen_imports/${id}`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

  export const clearSeniorCitizen = () => req.setList(c.GET_SENIOR_CITIZEN, []);

export const getIncidentList = (
  payload = { module_type: 'EHELP' },
  callback
) =>
  req.list(
    c.GET_INCIDENT,
    'api/v1/administrators/ehelp/incident_reports',
    payload,
    callback
  );

export const showIncidentList = (id, payload, callback) =>
req.item(
  c.SHOW_INCIDENT,
  `api/v1/administrators/ehelp/incident_reports/${id}`,
  payload,
  callback
);

export const clearIncident = () => req.setList(c.SHOW_INCIDENT, []);

export const createCitizen = (payload, callback) => 
req.create(
  c.CREATE_CITIZEN,
  'api/v1/administrators/social_amelioration_citizens',
  payload,
  ({ res }) => {
    const { data } = res.res;
    if (callback) callback({ data });
  },
);

export const updateCitizen = (id, payload, callback) => 
req.update(
  c.UPDATE_CITIZEN,
  `api/v1/administrators/social_amelioration_citizens/${id}`,
  payload,
  ({ res }) => {
    const { data } = res.res;
    if (callback) callback({ data });
  },
);

export const deactivateCitizen = (id, payload, callback) => 
req.update(
  c.DEACTIVATE_CITIZEN,
  `api/v1/administrators/social_amelioration_citizens/${id}/toggle_status`,
  payload,
  ({ res }) => {
    const { data } = res.res;
    if (callback) callback({ data });
  },
);

export const getPensionList = (payload, callback) =>
  req.list(
    c.GET_PENSIONS,
    'api/v1/administrators/social_amelioration_citizens/settings/pensions?is_active=1',
    payload,
    callback
  );